import { useContext, useEffect, useState } from "react";
import { Loader } from "@fluentui/react-northstar";
import "./MeetingTab.css";
import { TeamsFxContext } from "./Context";
import * as microsoftTeams from "@microsoft/teams-js";
import ContactInformation from "./ContactInformation";

export default function MeetingTab() {
    const { themeString, teamsfx, inTeams, context } = useContext(TeamsFxContext);
    const [currentUserEmail, setCurrentUserEmail] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (inTeams !== undefined) {
            setLoading(false)
        }
        // if (inTeams === true) {
        //     const fetchUserProfile = async () => {
        //         if (!teamsfx) {
        //             return;
        //         }

        //         let userInfo = await teamsfx.getUserInfo();
        //         setCurrentUserEmail(userInfo.preferredUserName);
        //         setLoading(false);
        //     }

        //     fetchUserProfile()
        //         .catch((error) => {
        //             alert(error.toString());
        //             setError(error);
        //             setLoading(false);
        //         }
        //         );;
        // }
    }, [inTeams, context]);

    const controlToRender = () => {
        if (loading) {
            return <Loader style={{ margin: 100 }} />;
        }
        else if (error) {
            return <div className="error">
                An unexpected error occurred. Please try again later. <br /> Details: {error.toString()}
            </div>;
        }
        else {
            switch (context.frameContext) {
                case microsoftTeams.FrameContexts.content:
                    return <div>content</div>                    
                case microsoftTeams.FrameContexts.sidePanel:
                    return <ContactInformation />
                case microsoftTeams.FrameContexts.meetingStage:
                    return <div>meetingStage</div>
                default:
                    return <div>unknown frame context '{context.frameContext}'</div>
            }
        }
    }

    return (
        <div className={themeString === "default" ? "" : "dark"}>
            <div className="meetingtab page">
            
                    {controlToRender()}
            </div>
        </div>
    );
}
